import { c, classy, m } from '@onfido/castor';
import { useField } from '@onfido/castor-react';
import React from 'react';
import { withRef } from '../../utils';
export const Button = withRef(function Button({ kind = 'action', variant = 'primary', className, ...restProps }, ref) {
    const { disabled } = useField();
    const Element = restProps.href ? 'a' : 'button';
    return (React.createElement(Element, { ...(Element === 'button' && {
            disabled, // will be overriden by props if set
        }), ...restProps, ref: ref, className: classy(c('button'), m(`${kind}--${variant}`), className) }));
});
//# sourceMappingURL=button.js.map